//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngTermsOfUse', srsngTermsOfUse);

    function srsngTermsOfUse($rootScope, Event) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/software-info/terms-of-use/terms-of-use.html',
            scope: {
            },
            controller: controller
        };

        function controller($scope) {
            // this is intentional override
        }

    }

})();

